<template></template>
<script>
export default {
  mounted() {
    this.$store
      .dispatch("customers/delete", this.$route.params.id)
      .then(resp => {
        this.$router.push({ name: "customers" });
        this.$notify({
          type: "success",
          message: this.$t('customer.message.successadd')
        });
      })
      .catch(error => {
        this.$notify({
          type: "danger",
          message: this.$t('customer.message.errordelete')
        });
      });
  }
};
</script>
<style>
</style>
